import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { ImportLog, ImportResult } from '@taksikortti/shared';

// API response shape matches @taksikortti/shared ImportResult exactly — the
// server slims `affectedCards` (full string[]) down to `affectedCardCount`
// before sending, so we never deserialise tens of thousands of card numbers.
export type ImportOutcome = ImportResult;

// --- Background import: upload → server-side queue worker ------------------

export interface UploadImportResponse { importId: string; totalRows: number }

/** Upload the raw CSV; the backend stores it and processes it on a queue worker. */
export function uploadImport(file: File) {
  return api<UploadImportResponse>('/imports/upload', {
    method: 'POST',
    rawBody: true,
    headers: { 'content-type': 'text/csv', 'x-taksikortti-filename': file.name },
    body: file,
  });
}

export interface ImportsListResponse {
  yearMonth: string;
  rows: ImportLog[];
}

export function useImportsList(yearMonth?: string) {
  return useQuery({
    queryKey: ['imports', 'list', yearMonth ?? 'current'],
    queryFn: () => api<ImportsListResponse>(`/imports${yearMonth ? `?yearMonth=${yearMonth}` : ''}`),
    staleTime: 5_000,
    // Light poll so an in-progress import's % updates live in the Recent list.
    refetchInterval: 10_000,
  });
}
